import axios from "axios";
import { getUserToken } from "../helpers/local_storage_helpers";
import { userFarmingCommodityApi, userExpanseDataApi, commodityMasterApi, combinedDropDownUserFarmingApi, userFarmingCommodityDataApi } from "../constants/apis";

export const getMyCropsData = async (userId) => {
    try {
        const config = {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Token ${getUserToken()}`,
            },
        };

        const response = await axios.get(
            `${userFarmingCommodityApi}${userId}`,
            config
        );

        return response;
    } catch (error) {
        console.error("Error fetching crops data:", error);
        throw error;
    }
};

export const createCrop = async (cropData) => {
    try {
        const config = {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Token ${getUserToken()}`,
            },
        };

        const response = await axios.post(
            userExpanseDataApi,
            cropData,
            config
        );

        return response;
    } catch (error) {
        console.error("Error creating crop:", error);
        throw error;
    }
};

export const getCropsMasterData = async (userId) => {
    try {
        const config = {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Token ${getUserToken()}`,
            },
        };

        const response = await axios.get(
            `${commodityMasterApi}?user_id=${userId}`,
            config
        );

        return response;
    } catch (error) {
        console.error("Error fetching crops data:", error);
        throw error;
    }
};

export const getCropsMasterDataNoUser = async () => {
    try {
        const config = {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Token ${getUserToken()}`,
            },
        };

        const response = await axios.get(
            `${commodityMasterApi}`,
            config
        );

        return response;
    } catch (error) {
        console.error("Error fetching crops data:", error);
        throw error;
    }
};

export const getMasterDropdownData = async (userId, commodityId) => {
    try {
        const config = {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Token ${getUserToken()}`,
            },
        };

        const response = await axios.get(
            `${combinedDropDownUserFarmingApi}${userId}&commodity_id=${commodityId}`,
            config
        );

        return response;
    } catch (error) {
        console.error("Error fetching crops data:", error);
        throw error;
    }
};

export const userFarmingCommodityData = async (data) => {
    try {
        const config = {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Token ${getUserToken()}`,
            },
        };

        const response = await axios.post(
            `${userFarmingCommodityDataApi}`,
            data,
            config
        );

        return response;
    } catch (error) {
        console.error("Error fetching crops data:", error);
        throw error;
    }
};
